export default __webpack_public_path__ + "static/media/web.8fce5d10.png";